var defaults = {
    skipFbReplyFormatting: true,
    useNewContentViewerInOldWidget: false,
    showCategoryPageAnchors: false,
    newPhoneTicketResolving: true,
    hideKeywordsAdder: true,
    disableCallRecording: false,
    newIvrSettings: true,
    useNewPublicApis: true,
    disableTicketCountersPolling: false,
    removeAccountLocale: true,
    onboardingArticles: false,
    queueWaitOffer: true,
    ccInsights: true,
    newTableEditor: true,
    widgetBusinessHours: false,
    transcribeCallcenterVoicemails: true,
    ruleEngineSetTicketLanguage: true,
    extendChatCountPolling: false,
    rtMenuChatStats: true,
    rtChatListStats: true,
    rtChatListSearch: true,
    migrateTicketPagePreferencesToUserStorage: true,
    routeToQueueCallPriority: false,
    serdesFixSelfClosingIframe: false,
    publicChatReplies: false,
    callWithoutDeviceBeacon: false,
    editTeamNote: true,
    transferTicketEnabled: true,
    internalReplyLinkedArticles: false
};
// tslint:disable-next-line:max-line-length
export var isLegacyFeaturedEnabledByDefault = function (key) {
    return defaults[key];
};
export var getLegacyFeatureToggleKeys = function () {
    return Object.keys(defaults);
};
//# sourceMappingURL=index.js.map